import AutomatonsAdmin from './AutomatonsAdmin.redux';

export default AutomatonsAdmin;
